<template>
  <el-form ref="form" :model="form">
    <el-row type="flex" class="gj-picker">
      <div class="gj-picker__editor">
        <div class="gj-picker__select--header flex align-center" style="line-height: 1;">

          <gj-market-select v-model="marketId" @input="marketValueChange($event)"></gj-market-select>

          <gj-select-input
              v-model="filter.exactAsin"
              :options="option.saleOrderDynKey3"
              :width="['100px', '160px']"
              @input="changeFuzzyParamType"
              class="gj-picker__select--input"
          >
            <template #suffix>
              <span class="main-list-filter--seg"></span>
            </template>
          </gj-select-input>

          <gj-button
              type="primary"
              class="gj-picker__select--input"
              @click="searchASIN"
          >查询</gj-button>

        </div>
        <div class="gj-picker__editor--body">
          <gj-table
              :index="false"
              :adapt-height="false"
              :height="400"
              :data="tableData"
              stripe
              border="inner"
              :loading="loading"
              :columns="columns0"
              :pagination="pagination"
              :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
              @page-change="$gjNoticeQuery"
          >
            <template v-slot:header:op>
              <gj-button type="text" :disabled="addAllBtn" @click="addAllItem(tableData)">添加全部</gj-button>
            </template>
            <template v-slot:listingTitle="{ index, row }">
              <div style="margin: 4px 0;">
                <el-row>
                  <el-col :span="24">
                    <span
                        style="font-weight: 600;"
                    >{{ row.marketId | optionText(marketOption) | defaultShow }}</span>
                  </el-col>
                </el-row>
                <gj-tooltip
                    :text-line="1"
                    :content="row.listingTitle"
                >{{row.listingTitle | defaultShow}}</gj-tooltip>
                <el-row v-if="false" type="flex" align="middle" v-gutter="8">
                  <el-rate :value="row.star" disabled style="display: inline;" text-color="#ff9900"></el-rate>
                  <span>({{row.star}})</span>
                  <el-divider direction="vertical"></el-divider>
                  <span style="color: #CC0000">${{row.price | defaultShow}}</span>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <a :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</a>
                  </el-col>
                  <el-col :span="14">{{row.msku | defaultShow}}</el-col>
                </el-row>
              </div>
            </template>
            <template v-slot:op="{ index, row }">
              <template v-if="isMeaningless(row.exitAds) || row.exitAds === 0">
                <el-tooltip
                    class="item"
                    v-if="row.btnStatus"
                    effect="dark"
                    content="此ASIN已添加到监控列表"
                    placement="top"
                >
                  <el-button class="disable" type="ghost" size="mini">添加</el-button>
                </el-tooltip>
                <gj-button
                    v-else
                    size="mini"
                    type="ghost"
                    :disabled="row.btnStatus"
                    style="padding: 5px 15px;"
                    @click="addItem(index, row)"
                >添加</gj-button>
                <gj-button
                    v-if="isMeaningful(row.variationAsin)"
                    type="text"
                    :disabled="row.btnStatus"
                    :loading="row.variationAsinLoading"
                    style="margin-left: 4px;"
                    @click="addVariationItem(index, row)"
                >添加变体</gj-button>
              </template>
              <template v-else>
                <gj-button size="mini" type="text" disabled style="margin-left: 4px;">已添加</gj-button>
              </template>
            </template>
          </gj-table>
        </div>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title" style="font-size: 12px">
          已添加 {{form.items.length}} 个{{title}}
          <span
              class="gj-picker__table--tip"
          >（剩余可添加{{remainingFollowUpMonitor - form.items.length}}个ASIN）</span>
        </div>
        <gj-table
            ref="gjTable"
            name="adAddKeyword"
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :height="440"
            :data="form.items"
            :columns="columns"
            border="inner"
        >
          <template v-slot:header:op>
            <gj-button type="text" :disabled="!form.items.length" @click="deleteAllItem()">全部移除</gj-button>
          </template>
          <template v-slot:listingTitle="{ index, row }">
            <div style="margin: 4px 0;">
              <el-row>
                <el-col :span="24">
                  <span
                      style="font-weight: 600;"
                  >{{ row.marketId | optionText(marketOption) | defaultShow }}</span>
                </el-col>
              </el-row>
              <gj-tooltip
                  :text-line="1"
                  :content="row.listingTitle"
              >{{row.listingTitle | defaultShow}}</gj-tooltip>
              <el-row v-if="false" type="flex" align="middle" v-gutter="8">
                <el-rate :value="row.star" disabled style="display: inline;" text-color="#ff9900"></el-rate>
                <span>({{row.star}})</span>
                <el-divider direction="vertical"></el-divider>
                <span style="color: #CC0000">${{row.price | defaultShow}}</span>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <a :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</a>
                </el-col>
                <el-col :span="14">{{row.msku | defaultShow}}</el-col>
              </el-row>
            </div>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button type="text" @click="deleteItem(index, row)">移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
  </el-form>
</template>

<script>
  import {
    formMixin,
    isMeaningfulMixin,
    queryMixin,
    isMeaninglessMixin
  } from "@/minxins";
  import {
    defaultVal,
    isMeaningful,
    isMeaningless,
    unique
  } from "@/utils/common";
  import { getListingPage } from "@/api/ad";
  import { getPackageQuota, getExistingGoods } from "@/api/tool";
  import { getSimpleListings } from "@/api/sale";
  import { AdTypeEnum } from "@/views/modules/tool/monitor/add/common/enum";
  import { saleOrderDynKey3 } from "@/utils/options";
  import { mapGetters } from "vuex";

  export default {
    name: "app-product-picker",
    mixins: [isMeaningfulMixin, formMixin, queryMixin, isMeaninglessMixin],
    props: {
      title: {
        required: true
      },
      // marketId: {
      //   required: true
      // },
      groupRequired: {
        type: Boolean,
        default: false
      },
      groupId: {
        default: null
      },
      width: {
        type: Array,
        default: () => ["130px", "130px"]
      }
    },
    computed: {
      ...mapGetters({
        marketOption: "marketOption"
      })
    },
    created() {
      this.columns[0].header = this.title;
      //获取跟卖监控剩余数量
      getPackageQuota().then(res => {
        if (res) {
          this.remainingFollowUpMonitor = res.remainingFollowUpMonitor;
        }
      });
      getExistingGoods().then(res => {
        this.asinData = res;
      });
    },
    data() {
      return {
        parentAsin: "",
        tableData: [],
        keyword: null,
        filter: {
          exactAsin: {
            key: "asin",
            value: null
          },
          fuzzyParamType: "asin,msku",
          countryCodes: []
        },
        marketValue: [],
        marketId: "",
        option: {
          saleOrderDynKey3: saleOrderDynKey3
        },
        columns0: [
          {
            id: "picture",
            header: "图片",
            field: "picture:imageUrl",
            width: "65px"
          },
          {
            id: "listingTitle",
            header: "店铺/商品标题/ASIN/MSKU",
            field: "slot:listingTitle",
            minWidth: "180px"
          },
          { id: "op", header: "slot:op", field: "slot:op", width: "100" }
        ],
        columns: [
          {
            id: "picture",
            header: "图片",
            field: "picture:imageUrl",
            width: "65px"
          },
          {
            id: "listingTitle",
            header: "店铺/商品标题/ASIN/MSKU",
            field: "slot:listingTitle",
            minWidth: "180px"
          },
          { id: "op", header: "slot:op", field: "slot:op", width: "80" }
        ],
        isMeaningful: isMeaningful,
        remainingFollowUpMonitor: 100,
        asinData: [],
        btnStatus: false,
        addAllBtn: false,
        allListAdd: []
      };
    },
    watch: {
      groupId: {
        handler(groupId) {
          if (isMeaningful(groupId)) {
            this.$gjNoticeQuery();
          }
        }
      },
      value: {
        handler(value) {
          this.marketValue = value ? defaultVal(value.marketIds, []) : [];
        },
        immediate: true
      }
    },
    methods: {
      $gjQuery() {
        if (this.groupRequired && isMeaningless(this.groupId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            groupId: this.groupId,
            fuzzyParamType: this.filter.fuzzyParamType || "asin,msku",
            status: "Active",
            adsType: AdTypeEnum.SP,
            fuzzyParam: this.filter.exactAsin.value,
            countryCodes: this.filter.countryCodes
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getSimpleListings(params)
          .then(data => {
            if (isMeaningful(data) && isMeaningful(data.records)) {
              this.allListAdd = data.records.filter(item => {
                return item.btnStatus !== true;
              });
              this.allListAdd.length < 1 ? this.addAllBtn = true : this.addAllBtn = false;
              this.tableData = data.records.map(e => ({
                ...e,
                listingTitle: e.title
              }));
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
            this.refreshBtnDisable();
          })
          .complete(() => (this.loading = false));
      },
      //筛选店铺
      marketValueChange() {
        this.$emit("input", {
          countryIds: this.countryValue,
          marketIds: this.marketValue
        });
      },
      //切换搜索类型
      changeFuzzyParamType(params) {
        this.filter.fuzzyParamType = params.key;
      },
      //搜索
      searchASIN() {
        this.pagination.currentPage = 1
        this.$gjQuery();
      },
      addAllItem(items) {
        if (this.allListAdd.length < 1) {
          this.addAllBtn = true;
        } else {
          this.addAllBtn = false;
          this.form.items = unique(
            [].concat(this.form.items).concat(items || this.allListAdd),
             ["msku","marketId"]
          );
          this.refreshBtnDisable();
        }
      },
      addItem(index, row) {
        this.form.items = unique(
          [].concat(this.form.items).concat([row]),
           ["msku","marketId"]
        );
        this.refreshBtnDisable();
      },
      refreshBtnDisable() {
        this.tableData.forEach(e1 => {
          if (this.form.items.some(e2 => e1.msku === e2.msku)) {
            this.$set(e1, "btnDisabled", true);
          } else {
            this.$set(e1, "btnDisabled", false);
          }
        });
        this.dataContrast()
      },
      addVariationItem(index, row) {
        // 将变体的主体也带入
        this.addItem(null, this.tableData[index])
        this.$set(row, "variationAsinLoading", true);
        getListingPage({
          model: {
            marketId: this.marketId,
            status: "Active",
            exactVariationAsin: row.variationAsin
          },
          current: 1,
          size: 999999
        })
          .then(data => {
            if (isMeaningful(data) && isMeaningful(data.records)) {
              this.addAllItem(
                data.records.map(e => ({
                  ...e,
                  listingTitle: e.title
                }))
              );
            }
          })
          .complete(() => this.$set(row, "variationAsinLoading", false));
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      formValidate() {
        const valid = this.form.items.length > 0;
        if (!valid) {
          this.$gjMessage.error("请添加商品");
        }
        return valid;
      },
      dataContrast() {
        // 过滤已经添加监控的数据
        if (this.form.items.length > 0) {
          this.form.items = this.form.items.filter(item => {
            return this.asinData.every(val => {
              return !(item.marketId === val.marketId && item.asin === val.asin)
            })
          })
        }
        // 将已经设定的数组和已选数组合并
        let allArr = unique(
            [].concat(this.form.items).concat(this.asinData),
            ["asin", "marketId"]
        );
        // 对已选择的数据按钮进行禁用
        this.tableData.forEach(item => {
          this.$set(item, "btnStatus", allArr.some((val, index) => {
            return (item.marketId === val.marketId) 
            && (item.asin === val.asin) 
          }));
        })
        // 所有数据已选则禁用addAllBtn
        this.addAllBtn = !this.tableData.filter(item => !item.btnStatus).length
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "picker";


  .gj-picker__editor {
    height: auto;
    width: 520px;
    padding: 0;
  }
  //.gj-picker__table {
  //  width: calc(100% - 540px);
  //}
  .gj-picker__table {
    width: 520px;
  }
  /deep/ .el-input-group__append {
    border-radius: 0;
    border: none;
    padding: 0 14px;
  }
  /deep/ .el-pagination .btn-prev {
    padding-right: 3px;
  }
  /deep/ .el-pagination .btn-next {
    padding-left: 3px;
  }
  /deep/ .el-pagination__total {
    margin-right: 2px;
  }
  /deep/ .footer__pagination {
    margin-right: 0;
    padding: 7px 16px !important;
  }
  /deep/ .el-pagination {
    padding-right: 0;
  }
  /deep/ .el-pagination .el-select .el-input {
    width: 90px;
  }
  /deep/ .el-pagination__sizes .el-select {
    // top: -4px;
  }
  //修正本组件在el-form下样式差异
  /deep/ .footer__pagination {
    // height: 40px;
    // line-height: 40px;
    //border-bottom: 1px solid #d9d9d9;
    // padding: 0 !important;
  }
  /deep/ .el-pagination,
  .el-pagination--small {
    // height: 40px;
    // line-height: 40px;
    // padding: 0;
    .el-pager{
      display: flex;
      align-items: center;
    }
  }
  /deep/ .el-pagination--small span:not([class*="suffix"]) {
    vertical-align: middle;
  }
  /deep/ .el-pagination {
    li {
      vertical-align: middle;
    }
    button {
      vertical-align: middle;
    }
  }

  /deep/ .el-col-10 > a {
    color: #1F6EEF;
    text-decoration-line: none;
  }
  .disable {
    padding: 5px 15px;
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
  /deep/.gj-picker__select--header{
    padding: 8px 10px;
    border-bottom: 1px solid #d9d9d9;
    height:auto;
    line-height: 1;
  }
  /deep/.gj-picker__table--title{
    height: 32px;
    padding: 8px 10px;
    line-height: 32px;
  }
  /deep/.gj-picker{
    height: auto;
  }
</style>

